import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5562 16.25C15.5562 15.1839 15.5562 14.6509 15.4246 14.2172C15.1284 13.2406 14.3642 12.4764 13.3876 12.1802C12.9539 12.0486 12.4209 12.0486 11.3548 12.0486H7.53538C6.46932 12.0486 5.93629 12.0486 5.50256 12.1802C4.526 12.4764 3.76179 13.2406 3.46556 14.2172C3.33398 14.6509 3.33398 15.1839 3.33398 16.25M12.8826 5.9375C12.8826 7.83598 11.3436 9.375 9.44509 9.375C7.54662 9.375 6.00759 7.83598 6.00759 5.9375C6.00759 4.03902 7.54662 2.5 9.44509 2.5C11.3436 2.5 12.8826 4.03902 12.8826 5.9375Z",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPerson;
